import * as React from 'react';
import * as gls from '../../../ap/layout/gls';
import * as styles from '../../../ap/base/styles';
import { i18n } from "../../../config/i18n";
import { Anchor } from '../../../ap/base/anchor';
import { TextInputField } from '../../../ap/fields/inputField';
import {DisplayValueSelectField, DisplayValue} from '../../../ap/fields/selectField';
import { appState } from '../../../state/state';
import { appendAddressElement } from './addressInputHelpers'

const {voi} = appState;

const EVENT_KEY_ENTER = "Enter";
const EVENT_KEY_SPACE = " ";

export interface ManualAddressEntryProps {
  id: string,
  switchToLookup: () => void
}

export interface ManualAddressEntryState {
}

/**
 * Some values powering the UI
 */
const userDetailsForm = {
  states: [
    "NSW", "VIC", "QLD", "SA", "WA", "ACT", "NT", "TAS"
  ]
};

class ManualAddressEntry extends React.Component<ManualAddressEntryProps, ManualAddressEntryState> {

  constructor(props) {

    super(props);

    this.state = props.state;
  }

  states: DisplayValue[] = [{ display: i18n('selectState'), value: '' }]
    .concat(userDetailsForm.states.map(key => ({ display: i18n(key), value: key })));

  handleSwitchToLookupAction = (event) => {
    if (event.key === EVENT_KEY_ENTER || event.key === EVENT_KEY_SPACE) {
      this.props.switchToLookup();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  buildId(innerId: string) {
    return this.props.id + "-" + innerId;
  }

  updateFullClientAddress = () => {
    let streetAddress = {addressLine: voi.addressLine1.value};

    appendAddressElement(streetAddress, voi.addressLine2.value);
    appendAddressElement(streetAddress, voi.suburb.value);
    appendAddressElement(streetAddress, voi.state.value.value);
    appendAddressElement(streetAddress, voi.postcode.value);

    voi.fullClientAddress = streetAddress.addressLine;

    if (voi.useClientAddressAsTransacted) {
      voi.propertyBeingTransacted.setValue(voi.fullClientAddress)
    }
  }

  onClientAddressChanged = (event) => {
    this.updateFullClientAddress();
  }

  onChangeClientAddressState = (value: DisplayValue) => {
    voi.state.setValue(value);
    this.updateFullClientAddress();
  }

  render() {

    return (
      <div id={this.buildId("address-manual-entry-fields")}>
        <gls.ContentVerticalContentMargined margin={styles.spacing.verticalBetweenFields}>

            <TextInputField  id={this.buildId("addressLine1")}
                             name="addressLine1"
                             label={i18n("addressLine1")}
                             fieldState={voi.addressLine1}
                             onKeyUp={this.onClientAddressChanged}
                             star={true}
                             autoFocus={true}
            />
            <TextInputField  id={this.buildId("addressLine2")}
                             name="addressLine2"
                             label={i18n("addressLine2")}
                             fieldState={voi.addressLine2}
                             onKeyUp={this.onClientAddressChanged}
            />
            <TextInputField  id={this.buildId("suburb")}
                             name="suburb"
                             label={i18n("suburb")}
                             fieldState={voi.suburb}
                             onKeyUp={this.onClientAddressChanged}
                             star={true}
            />

            <gls.ResponsiveGridParent margin={styles.spacing.horizontalBetweenFields}>
              <DisplayValueSelectField
                id={this.buildId("state")}
                name="state"
                label={i18n("state")}
                fieldState={voi.state}
                values={this.states}
                onChange={this.onChangeClientAddressState}
                star={true}
              />
              <TextInputField  id={this.buildId("postcode")}
                               name="postcode"
                               label={i18n("postcode")}
                               fieldState={voi.postcode}
                               onKeyUp={this.onClientAddressChanged}
                               star={true}
              />
            </gls.ResponsiveGridParent>

            <gls.ResponsiveGridParent margin={styles.spacing.verticalBetweenFields}>
              <Anchor
                tabIndex={0}
                onClick={this.props.switchToLookup}
                onKeyDown={this.handleSwitchToLookupAction}
                onKeyUp={this.handleSwitchToLookupAction}
                onKeyPress={this.handleSwitchToLookupAction}
              >
                <span>Switch back to address lookup</span>
              </Anchor>
            </gls.ResponsiveGridParent>
        </gls.ContentVerticalContentMargined>
      </div>
    );
  }
}

export default ManualAddressEntry;
